import { Injectable, ErrorHandler } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IAddressDto, IClient } from '../models';
import { KeyValue } from '@angular/common';

@Injectable()
export class CommonService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }
  public getOutletAddress(id: number): Observable<IAddressDto> {
    return this.get(`common/outletAddress/${id}`);
  }

  public getClient(): Observable<IClient> {
    const model = { key: 0, value: window.location.origin } as KeyValue<
      number,
      string
    >;
    model.value = model.value
      .replace(/^(?:https?:\/\/)?(?:www\.)?/i, '')
      .split('/')[0];
    return this.post(`common/client`, model);
  }
}
